export default "__VITE_ASSET__0F5wP0bj__"